namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmRokDenikuSsl extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmRokDenikuSslReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmRokDenikuSslObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmRokDenikuSslObj());
            this.detailObj.createBase({
                contentName: "detailAdmRokDenikuSsl",
                contentCaption: "jres:33000613", //RC 33000613 : Rok podacího deníku
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                addAktivita: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmRokDenikuSsl", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmRokDenikuSslObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmRokDenikuSslReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return "{0} - {1}".format(this.data["sslden"]?.toString(), this.data["rok"]?.toString()) 
        }

        setSxsDetail(): string {
            return "{0}#{1}#".format((this.data.sslden) ? this.data.sslden.toString() : "", (this.data.rok) ? this.data.rok.toString() : "");
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmRokDenikuSslSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmRokDenikuSsl.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmRokDenikuSsl", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmRokDenikuSsl.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, this.textPopis()?.toString());
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("sslden", Gordic.Prefabs.Select.sslsden(), {
                model: "model.sslden=value.sslden",
                itemTemplate: "{sslden}"
            })
            this.MakeField("rok", { validators: [ this.createValidatorRok() ] });
            this.MakeField("por_cislo_od");
            this.MakeField("por_cislo_do");
            this.MakeField("por_cislo_max");
            this.MakeSelectField("stav_uzav", Gordic.Prefabs.Select.admSslcstu(), { model: "model.stav_uzav=value.stav_uzav" })
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }

        private createValidatorRok(): Gordic.Validators.Base {
            var year = new Date().getFullYear();
            var validator = new Gordic.Validators.Base({ message: "jres:33000618".format(year - 100, year + 100) }); //RC 33000618 : Hodnota roku musí být v rozmezí {0} a {1}.
            validator.stopping = true;
            validator.validate = (value, source) => {
                if (this.options.newRecord == false)
                    return true;
                var year = new Date().getFullYear();
                if ((value <= (year + 100)) && (value >= (year - 100)))
                    return true;
                return false;
            }
            return validator;
        }
    }
}